/*

THIS IS JUST AN EXAMPLE SET UP FOR A REDUCER.
WE CAN DO WHATEVER WE WANT IN IT I JUST WANTED TO GIVE A BASE SKELETON - SAMEER

*/

import * as types from '../actions/actionTypes';

export const navigationReducer = (state = { checkoutStep: 1, canContinue: false, loading: true, showError: false, attempts: 0, errorText: '', confirmSchedule: false, confirmationSuccess: false }, action) => {
    var newState = { ...state }
    switch (action.type) {
        case types.SET_CHECKOUT_STEP:
            newState.checkoutStep = action.payload;
            newState.attempts = 0;
            return newState;
            break;
        case types.SET_CAN_CONTINUE:
            newState.canContinue = action.payload
            return newState
            break;
        case types.SET_LOADING:
            newState.loading = action.payload
            return newState;
            break;
        case types.SET_SHOW_ERROR:
            newState.showError = action.payload.showError;
            newState.errorText = action.payload.showError ? action.payload.errorText : '';
            return newState;
            break;
        case types.INCREMENT_ATTEMPTS:
            newState.attempts += 1;
            return newState; 
            case types.SET_CONFIRM_SCHEDULE:
              newState.confirmSchedule = action.payload;
              return newState;
          case types.SET_CONFIRMATION_SUCCESS:
              newState.confirmationSuccess = action.payload;
              newState.confirmSchedule = false;
              return newState;
              break;   
        default:
            return state;
    }
}
